import gql from 'graphql-tag';

const LOG_MYSTAGE = gql`
  mutation LogMyStage($input: [LogMyStageInput]!) {
    logMyStage(input: $input)
  }
`;

export { LOG_MYSTAGE };
